var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  "+_vm._s(_vm.project && _vm.project.hasOwnProperty('name') && _vm.project.hasOwnProperty('state') && _vm.project.name !== '' && _vm.project.state !== '' ? ("- " + (_vm.project.name) + " / " + (_vm.project.state)) : 'Projeto ainda não configurado')+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40eb9694","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectName.vue
// module id = oixv
// module chunks = 10